import React from 'react';
import BzmIcon from '../../../components/icons/BzmIcon';
import i18n from '../../../i18n';

export const createAiAssistantIcon = () => (
  <BzmIcon title={'AI Assistant'} className="icon-xs text-primary" variant={'icon-bzm-ai-stars'} />
);
